<div class="row update-tax-strategy tax-estimates-inputs new-input-fields" *ngIf="hasData">
  <div class="column medium-12 mt-2 mb-3">
    <div style="float: left; padding-top: 5px;">
      <span class="auto-save-status" style="font-size: 12px;">
        <span *ngIf="saveStatus === 'saving'" style="color: #999;">Saving...</span>
        <span *ngIf="saveStatus === 'saved'" style="color: #28a745;">Saved</span>
        <span *ngIf="saveStatus === 'error'" style="color: #dc3545;">Save failed</span>
      </span>
    </div>
    <div style="float: right">
      <button *ngIf="!taxEstimates.status || (taxEstimates.status && taxEstimates.status != 'publish')" class="button small" style="margin-bottom: 0 !important;" (click)="publishProjection('publish')">Publish</button>
      <button *ngIf="taxEstimates.status && taxEstimates.status == 'publish'" class="button small" style="margin-bottom: 0 !important;" (click)="publishProjection('unpublish')">Unpublish</button>
      <button class="button small" style="margin-bottom: 0 !important;" (click)="saveTaxProjection()">Save</button>
      <span class="icons report-icon-header" style="margin-left: 5px;position: relative;top: 5px;">
        <i class="icon ion-ios-cloud-download-outline" data-toggle="projection-download"></i>
        <div class="dropdown-pane pdf-export-dropdown" id="projection-download" data-dropdown data-hover="true" data-hover-pane="true" foundation>
          <div (click)="projectionToPdf()" class="export-option">Export into pdf</div>
          <div (click)="exportToExcel()" class="export-option">Export into excel</div>
        </div>
      </span>
    </div>
  </div>
  <div class="column medium-6">
    <div class="row">
      <div class="column medium-4 mt-1">
        <label class="user-title">Prior Year Tax</label>
      </div>
      <div class="column medium-8">
        <input type="text"  placeholder="Prior Year Tax" [(ngModel)]="taxEstimates.priorYearTax" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateSafeHarbor()" (ngModelChange)="markDirty()"/>
      </div>
    </div>
    <div class="row">
      <div class="column medium-4 mt-1">
        <label class="user-title">Prior Year Tax AGI</label>
      </div>
      <div class="column medium-8">
        <input type="text"  placeholder="Prior Year Tax AGI" [(ngModel)]="taxEstimates.priorYearAGI" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateSafeHarbor()" (ngModelChange)="markDirty()"/>
      </div>
    </div>
    <div class="row">
      <div class="column medium-4 mt-1">
        <label class="user-title">Filing Status</label>
      </div>
      <div class="column medium-8">
        <label>
          <app-tpiq-select-dropdown [includeNone]="false" [setData]="filingStatusList" [setPlaceHolder]="'Filing Status'" [setSearchKey]="'name'" [setValueKey]="'name'" [setDefaultValue]="taxEstimates.filingStatus"
                                 (onValueSelect)="onFilingSelect($event)"></app-tpiq-select-dropdown>
        </label>
      </div>
    </div>
  </div>
  <div class="column medium-6">
    <div class="row">
      <div class="column medium-4 mt-1">
        <label class="user-title">Current Year Tax</label>
      </div>
      <div class="column medium-8">
        <input type="text"  placeholder="Current Year Tax" [(ngModel)]="taxEstimates.currentYearTax" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateTaxDue()" (ngModelChange)="markDirty()"/>
      </div>
    </div>
    <div class="row">
      <div class="column medium-4 mt-1">
        <label class="user-title">Current Year Tax AGI</label>
      </div>
      <div class="column medium-8">
        <input type="text"  placeholder="Current Year Tax AGI" [(ngModel)]="taxEstimates.currentYearAGI" model-numeral [locale]="'USD'" [format]="'$0,0'" (ngModelChange)="markDirty()"/>
      </div>
    </div>
    <div class="row">
      <div class="column medium-4 mt-1">
        <label class="user-title">Firm Notes</label>
      </div>
      <div class="column medium-8">
        <div style="border: 1px solid #cacaca; padding: 10px;" [froalaEditor]="editorOptions" [(froalaModel)]="taxEstimates.notes" (froalaModelChange)="markDirty()"></div>
      </div>
    </div>
  </div>
  <div class="column medium-12">
    <hr style="margin: 0.5rem auto !important;"/>
    <div class="row">
      <div class="column medium-9"></div>
      <div class="column medium-3 report-icon-header">
        <label>
          <app-tpiq-select-dropdown [includeNone]="false" [setData]="taxProjectionsList" [setPlaceHolder]="'Tax Projection'" [setSearchKey]="'name'" [setValueKey]="'name'" [setDefaultValue]="currentTaxProjection"
                                 (onValueSelect)="onTaxProjectionSelect($event)"></app-tpiq-select-dropdown>
        </label>
      </div>
    </div>
    <div class="row" *ngFor="let projection of projectionsArray">
      <div class="column medium-12 mb-4" *ngIf="showProjection && currentTaxProjection == projection.projectionName">
        <div class="row">
          <div class="column medium-12 bold" style="padding: 15px 0;">
            <span style="color: #475E79; font-size: 18px;">{{planYear}} {{projection.projectionName}}</span>
          </div>
          <div class="column medium-6">
            <div class="row mb-3" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <div class="column medium-9">
                <div *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                  <span class="user-title">Safe Harbor Tax Due</span>
                  <span class="text-center badge-tooltip">
                    <i class="icon ion-ios-information-outline" (click)="showCalculationInfo('safeHarbor')"></i>
                    <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                      Click here to link to see formula
                    </span>
                  </span>
                </div>
                <div class="mt-1" *ngIf="projection.projectionName == 'State Personal Tax Projection'">
                  <label class="user-title">Prior Year Tax Due</label>
                </div>
              </div>
              <div class="column medium-3">
                <div *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">{{projection.safeHarbor | taxEstimatesAmount:'$0,0'}}</div>
                <div *ngIf="projection.projectionName == 'State Personal Tax Projection'">
                  <input style="margin: 0;" type="text"  placeholder="" [(ngModel)]="projection.priorYearTaxDue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateMinAmountDueToIRS()" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="column medium-9">
                <div *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                  <span class="user-title">Current Year Expected Minimum Tax Due</span>
                  <span class="text-center badge-tooltip">
                    <i class="icon ion-ios-information-outline" (click)="showCalculationInfo('currentYearExpectedMinTaxDue')"></i>
                    <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                      Click here to link to see formula
                    </span>
                  </span>
                </div>
                <div class="mt-1" *ngIf="projection.projectionName != 'Federal 1040 Tax Projection'">
                  <label class="user-title">Current Year Expected Tax Due</label>
                </div>
              </div>
              <div class="column medium-3">
                <div *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">{{projection.currentYearExpectedMinTaxDue | formatAmount:'$0,0'}}</div>
                <div *ngIf="projection.projectionName != 'Federal 1040 Tax Projection'">
                  <input style="margin: 0;" type="text"  placeholder="" [(ngModel)]="projection.currentYearExpectedMinTaxDue" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateMinAmountDueToIRS()" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="row mb-3" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <div class="column medium-9">
                <span class="user-title">Minimum Amount Due to IRS</span>
                <span class="text-center badge-tooltip">
                    <i class="icon ion-ios-information-outline" (click)="showCalculationInfo('minimumAmountDueToIRS')"></i>
                    <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                      Click here to link to see formula
                    </span>
                </span>
              </div>
              <div class="column medium-3">
                {{projection.minimumAmountDueToIRS| formatAmount:'$0,0'}}
              </div>
            </div>
            <div class="row mb-2">
              <div class="column medium-9 mt-1">
                <label class="user-title">Over Payment Applied for PY</label>
              </div>
              <div class="column medium-3">
                <input style="margin: 0;" type="text"  placeholder="" [(ngModel)]="projection.overPaymentAppliedForPY" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRemainderDueOrRefund()" (ngModelChange)="markDirty()"/>
              </div>
            </div>
            <div class="row mb-2"  *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <div class="column medium-9 mt-1">
                <label class="user-title">Estimated W-2 Withholding-Taxpayer</label>
              </div>
              <div class="column medium-3">
                <input style="margin: 0;" type="text"  placeholder="" [(ngModel)]="projection.estimatedW2WithHolding" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRemainderDueOrRefund(true)" (ngModelChange)="markDirty()"/>
              </div>
            </div>
            <div class="row mb-3"  *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <div class="column medium-9 mt-1">
                <label class="user-title">Estimated W-2 Withholding-Spouse</label>
              </div>
              <div class="column medium-3">
                <input style="margin: 0;" type="text"  placeholder="" [(ngModel)]="projection.estimatedW2WithHoldingSpouse" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRemainderDueOrRefund(true)" (ngModelChange)="markDirty()"/>
              </div>
            </div>
          </div>
          <div class="column medium-6">
            <div class="row mb-2">
              <div class="column medium-12">
                <label class="user-title">
                  Note to client
                  <textarea rows="3" [(ngModel)]="projection.notes" (ngModelChange)="markDirty()"></textarea>
                </label>
              </div>
            </div>
          </div>
          <div class="column medium-12 bold" style="color: #110646;background-color: #E5E5E5;padding: 5px 0;border-radius: 5px;">
            <div class="row"  *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <div class="column medium-3"></div>
              <div class="column medium-2">Recommended</div>
              <div class="column medium-2">Paid</div>
              <div class="column medium-2">Paid Date</div>
              <div class="column medium-3">Notes</div>
            </div>
            <div class="row"  *ngIf="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
              <div class="column medium-2"></div>
              <div class="column medium-2">Due Date</div>
              <div class="column medium-2">Recommended</div>
              <div class="column medium-2">Paid</div>
              <div class="column medium-2">Paid Date</div>
              <div class="column medium-2">Notes</div>
            </div>
          </div>
          <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
            <div class="column medium-12 mt-3">
              <div class="row">
                <div class="column medium-3 mt-1">
                  <label class="user-title">Q1 Due 4/15</label>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter1.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter1.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter1.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter1', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-3">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter1.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3 mt-1">
                  <label class="user-title">Q2 Due 6/15</label>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter2.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter2.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter2.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter2', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-3">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter2.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3 mt-1">
                  <label class="user-title">Q3 Due 9/15</label>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter3.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter3.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter3.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter3', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-3">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter3.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3 mt-1">
                  <label *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'" class="user-title">Q4 Due 1/15</label>
                  <label *ngIf="projection.projectionName == 'State Personal Tax Projection'" class="user-title">Q4 Due 12/15</label>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter4.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter4.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter4.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter4', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-3">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter4.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3 mt-1">
                  <label class="user-title">Additional Payment1</label>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment1.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment1.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.addittionalPayment1.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'addittionalPayment1', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-3">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.addittionalPayment1.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3 mt-1">
                  <label class="user-title">Additional Payment2</label>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment2.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment2.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.addittionalPayment2.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'addittionalPayment2', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-3">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.addittionalPayment2.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3 mt-1">
                  <label class="user-title">Extension Payment</label>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.extensionPayment.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.extensionPayment.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.extensionPayment.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'extensionPayment', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-3">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.extensionPayment.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12" style="margin-top: 5px;">
              <div class="row">
                <div class="column medium-3 bold">Total Estimates</div>
                <div class="column medium-2">{{projection.recommendedEstimates  | formatAmount:'$0,0'}}</div>
                <div class="column medium-2">{{projection.paidEstimates  | formatAmount:'$0,0'}}</div>
                <div class="column medium-2"></div>
                <div class="column medium-3"></div>
              </div>
            </div>
          </ng-template>
          <ng-template [ngIf]="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
            <div class="column medium-12 mt-3">
              <div class="row">
                <div class="column medium-2 mt-1">
                  <label class="user-title">Q1</label>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter1.dueDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter1', 'due date')"  placeholder="Due Date"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter1.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter1.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter1.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter1', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter1.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2 mt-1">
                  <label class="user-title">Q2</label>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter2.dueDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter2', 'due date')"  placeholder="Due Date"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter2.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter2.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter2.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter2', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter2.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2 mt-1">
                  <label class="user-title">Q3</label>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter3.dueDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter3', 'due date')"  placeholder="Due Date"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter3.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter3.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter3.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter3', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter3.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2 mt-1">
                  <label class="user-title">Q4</label>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter4.dueDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter4', 'due date')"  placeholder="Due Date"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter4.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.quarter4.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.quarter4.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'quarter4', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.quarter4.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2 mt-1">
                  <label class="user-title">Additional Payment1</label>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.addittionalPayment1.dueDate"
                         (valueChanged)="dateChanged($event, projection, 'addittionalPayment1', 'due date')"  placeholder="Due Date"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment1.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment1.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.addittionalPayment1.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'addittionalPayment1', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.addittionalPayment1.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2 mt-1">
                  <label class="user-title">Additional Payment2</label>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.addittionalPayment2.dueDate"
                         (valueChanged)="dateChanged($event, projection, 'addittionalPayment2', 'due date')"  placeholder="Due Date"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment2.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.addittionalPayment2.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.addittionalPayment2.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'addittionalPayment2', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.addittionalPayment2.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2 mt-1">
                  <label class="user-title">Extension Payment</label>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.extensionPayment.dueDate"
                         (valueChanged)="dateChanged($event, projection, 'extensionPayment', 'due date')"  placeholder="Due Date"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.extensionPayment.recommended" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculateRecommendedEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input type="text"  placeholder="" [(ngModel)]="projection.extensionPayment.paid" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="calculatePaidEstimatesTotal(projection)"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="projection.extensionPayment.paidDate"
                         (valueChanged)="dateChanged($event, projection, 'extensionPayment', 'paid date')"  placeholder="Paid Date"/>
                </div>
                <div class="column medium-2">
                  <input class="float-left input-field" type="text" [(ngModel)]="projection.extensionPayment.notes" placeholder="Notes" (ngModelChange)="markDirty()"/>
                </div>
              </div>
            </div>
            <div class="column medium-12 mt-1">
              <div class="row">
                <div class="column medium-2 bold">Total Estimates</div>
                <div class="column medium-2"></div>
                <div class="column medium-2">{{projection.recommendedEstimates  | formatAmount:'$0,0'}}</div>
                <div class="column medium-2">{{projection.paidEstimates  | formatAmount:'$0,0'}}</div>
                <div class="column medium-2"></div>
                <div class="column medium-2"></div>
              </div>
            </div>
          </ng-template>
          <div class="column medium-12 mt-3">
            <div class="row">
              <div class="column medium-3 bold">Remainder Due/Refund
                <span class="text-center badge-tooltip">
                    <i class="icon ion-ios-information-outline" (click)="showCalculationInfo('remainderDueRefund')"></i>
                    <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                      Click here to link to see formula
                    </span>
                </span>
              </div>
              <div class="column medium-2">
                <span *ngIf="projection.isRemainderDueOrRefundNegative">({{projection.remainderDueRefund  | formatAmount:'$0,0'}})</span>
                <span *ngIf="!projection.isRemainderDueOrRefundNegative">{{projection.remainderDueRefund  | formatAmount:'$0,0'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column medium-12">
      <app-estimate-details #detailReport
      [currentPlanYear]="planYear"
      [filingStatus]="taxEstimates.filingStatus"
      [detailReport]="estimateDetailReport"
      [taxPlanData]="clientTaxplanData"
      [w2Change]="w2ValueChanged"
      [estimatesChange]="estimatesPaidCganged"
      [currentProjection]="currentTaxProjection"
      [projectionsData]="projectionsArray"
      [clientsList]="clientsList"
      [strategies]="strategiesList"
      [associatedWithData]="associatedWithData"
      [stateAssociatedWithData]="stateAssociatedWithData"
      [allAssociatedData]="allAssociatedData"
      [clientData]="clientData"
      (triggerRefreshStrategies)="triggerForRefreshPlan.emit()"></app-estimate-details>
      </div>
  </div>
</div>

<div  style="display: none;">
  <div id="tax-estimate-projection">
    <table style="font-size: 15px; margin-top: 30px; width: 100%;">
      <thead style="background: none;">
      <tr style="height: 50px;">
        <th style="text-align: center;" [ngStyle]="{'background-color': backgroundColor}">
          ````
        </th>
      </tr>

      <tr style="height: 36px;">
        <th style="text-align: center;font-size: 25px;color: #475E79;">
          Tax Estimates
        </th>
      </tr>
      <tr style="height: 36px;">
        <th style="text-align: center;font-size: 20px;color: #475E79;">
          {{clientTaxplanData.userName || ''}}
        </th>
      </tr>
      <tr style="height: 36px;">
        <th style="text-align: center;font-size: 18px;color: #475E79;">
          {{clientTaxplanData.name || ''}}
        </th>
      </tr>
      <tr style="height: 36px;">
        <th style="text-align: center;font-size: 18px;color: #475E79;">
          {{exportedDate || ''}}
        </th>
      </tr>
      <tr style="height: 20px;">
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <table style="width: 100%;">
            <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr style="height: 36px;">
              <td>Prior Year Tax</td>
              <td style="padding-left: 20px;">{{taxEstimates.priorYearTax | formatAmount:'$0,0'}}</td>
            </tr>
            <tr style="height: 36px;">
              <td>Prior Year Tax AGI</td>
              <td style="padding-left: 20px;">{{taxEstimates.priorYearAGI | formatAmount:'$0,0'}}</td>
            </tr>
            <tr style="height: 36px;">
              <td>Current Year Estimated Tax</td>
              <td style="padding-left: 20px;">{{taxEstimates.currentYearTax | formatAmount:'$0,0'}}</td>
            </tr>
            <tr style="height: 36px;">
              <td>Current Year Estimated Tax AGI</td>
              <td style="padding-left: 20px;">{{taxEstimates.currentYearAGI | formatAmount:'$0,0'}}</td>
            </tr>
            <tr style="height: 36px;">
              <td>Filing Status</td>
              <td style="padding-left: 20px;">{{taxEstimates.filingStatus}}</td>
            </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <ng-template [ngIf]="projectionsToPdf && projectionsToPdf.length > 0">
        <ng-template style="height: 36px;" ngFor [ngForOf]="projectionsToPdf" let-projection="$implicit" let-i="index">
          <tr style="height: 20px;">
            <td></td>
          </tr>
          <tr style="height: 20px;">
            <td style="color: #475E79; font-size: 18px;font-weight: bold;">{{planYear}} {{projection.projectionName}}</td>
          </tr>
          <tr>
            <td>
              <table style="width: 70%;">
                <thead>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
                  <tr style="height: 36px;" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                    <td>Safe Harbor Tax Due</td>
                    <td style="padding-left: 20px;">{{projection.safeHarbor | taxEstimatesAmount:'$0,0'}}</td>
                  </tr>
                  <tr style="height: 36px;" *ngIf="projection.projectionName == 'State Personal Tax Projection'">
                    <td>Prior Year Tax Due</td>
                    <td style="padding-left: 20px;">{{projection.priorYearTaxDue | formatAmount:'$0,0'}}</td>
                  </tr>
                  <tr style="height: 36px;" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                    <td>Current Year Expected Minimum Tax Due</td>
                    <td style="padding-left: 20px;">{{projection.currentYearExpectedMinTaxDue | taxEstimatesAmount:'$0,0'}}</td>
                  </tr>
                </ng-template>
                <ng-template [ngIf]="projection.projectionName != 'Federal 1040 Tax Projection'">
                  <tr style="height: 36px;">
                    <td>Current Year Expected Tax Due</td>
                    <td style="padding-left: 20px;">{{projection.currentYearExpectedMinTaxDue | taxEstimatesAmount:'$0,0'}}</td>
                  </tr>
                </ng-template>
                <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
                  <tr style="height: 36px;">
                    <td>Minimum Amount Due to IRS</td>
                    <td style="padding-left: 20px;">{{projection.minimumAmountDueToIRS | taxEstimatesAmount:'$0,0'}}</td>
                  </tr>
                </ng-template>
                <tr style="height: 36px;">
                  <td>Over Payment Applied for PY</td>
                  <td style="padding-left: 20px;">{{projection.overPaymentAppliedForPY | taxEstimatesAmount:'$0,0'}}</td>
                </tr>
                <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
                  <tr style="height: 36px;">
                    <td>Estimated W-2 Withholding-Taxpayer</td>
                    <td style="padding-left: 20px;">{{projection.estimatedW2WithHolding | taxEstimatesAmount:'$0,0'}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Estimated W-2 Withholding-Spouse</td>
                    <td style="padding-left: 20px;">{{projection.estimatedW2WithHoldingSpouse | taxEstimatesAmount:'$0,0'}}</td>
                  </tr>
                </ng-template>
                <tr style="height: 36px;">
                  <td>Note to client</td>
                  <td style="padding-left: 20px;width: 150px;">{{projection.notes}}</td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table style="width: 100%;">
                <thead>
                <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
                  <tr style="height: 36px;color: #110646;background-color: #E5E5E5;padding: 5px 0;">
                    <th></th>
                    <th style="text-align: center;">Recommended</th>
                    <th style="text-align: center;">Paid</th>
                    <th style="text-align: center;">Paid Date</th>
                    <th style="text-align: center;">Notes</th>
                  </tr>
                </ng-template>
                <ng-template [ngIf]="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
                  <tr style="height: 36px;color: #110646;background-color: #E5E5E5;padding: 5px 0;">
                    <th></th>
                    <th style="text-align: center;">Due Date</th>
                    <th style="text-align: center;">Recommended</th>
                    <th style="text-align: center;">Paid</th>
                    <th style="text-align: center;">Paid Date</th>
                    <th style="text-align: center;">Notes</th>
                  </tr>
                </ng-template>
                </thead>
                <tbody>
                <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
                  <tr style="height: 36px;">
                    <td>Q1 Due 4/15</td>
                    <td style="text-align: center;">{{projection.quarter1.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter1.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter1.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter1.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Q2 Due 6/15</td>
                    <td style="text-align: center;">{{projection.quarter2.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter2.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter2.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter2.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Q3 Due 9/15</td>
                    <td style="text-align: center;">{{projection.quarter3.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter3.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter3.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter3.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">Q4 Due 1/15</td>
                    <td *ngIf="projection.projectionName == 'State Personal Tax Projection'">Q4 Due 12/15</td>
                    <td style="text-align: center;">{{projection.quarter4.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter4.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter4.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter4.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Additional Payment1</td>
                    <td style="text-align: center;">{{projection.addittionalPayment1.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment1.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment1.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.addittionalPayment1.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Additional Payment2</td>
                    <td style="text-align: center;">{{projection.addittionalPayment2.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment2.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment2.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.addittionalPayment2.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Extension Payment</td>
                    <td style="text-align: center;">{{projection.extensionPayment.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.extensionPayment.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.extensionPayment.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.extensionPayment.notes}}</td>
                  </tr>
                  <tr style="height: 36px;font-weight: bold;">
                    <td>Total Estimates</td>
                    <td style="text-align: center;">{{projection.recommendedEstimates | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.paidEstimates | formatAmount:'$0,0'}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr style="height: 36px;font-weight: bold;">
                    <td>Remainder Due/Refund</td>
                    <td style="text-align: center;" *ngIf="projection.isRemainderDueOrRefundNegative">({{projection.remainderDueRefund  | formatAmount:'$0,0'}})</td>
                    <td style="text-align: center;" *ngIf="!projection.isRemainderDueOrRefundNegative">{{projection.remainderDueRefund  | formatAmount:'$0,0'}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </ng-template>
                <ng-template [ngIf]="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
                  <tr style="height: 36px;">
                    <td>Q1</td>
                    <td style="text-align: center;">{{projection.quarter1.dueDate}}</td>
                    <td style="text-align: center;">{{projection.quarter1.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter1.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter1.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter1.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Q2</td>
                    <td style="text-align: center;">{{projection.quarter2.dueDate}}</td>
                    <td style="text-align: center;">{{projection.quarter2.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter2.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter2.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter2.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Q3</td>
                    <td style="text-align: center;">{{projection.quarter3.dueDate}}</td>
                    <td style="text-align: center;">{{projection.quarter3.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter3.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter3.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter3.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Q4</td>
                    <td style="text-align: center;">{{projection.quarter4.dueDate}}</td>
                    <td style="text-align: center;">{{projection.quarter4.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter4.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.quarter4.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.quarter4.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Additional Payment1</td>
                    <td style="text-align: center;">{{projection.addittionalPayment1.dueDate}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment1.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment1.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment1.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.addittionalPayment1.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Additional Payment2</td>
                    <td style="text-align: center;">{{projection.addittionalPayment2.dueDate}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment2.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment2.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.addittionalPayment2.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.addittionalPayment2.notes}}</td>
                  </tr>
                  <tr style="height: 36px;">
                    <td>Extension Payment</td>
                    <td style="text-align: center;">{{projection.extensionPayment.dueDate}}</td>
                    <td style="text-align: center;">{{projection.extensionPayment.recommended | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.extensionPayment.paid | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.extensionPayment.paidDate}}</td>
                    <td style="text-align: center;width: 130px;">{{projection.extensionPayment.notes}}</td>
                  </tr>
                  <tr style="height: 36px;font-weight: bold;">
                    <td>Total Estimates</td>
                    <td></td>
                    <td style="text-align: center;">{{projection.recommendedEstimates | formatAmount:'$0,0'}}</td>
                    <td style="text-align: center;">{{projection.paidEstimates | formatAmount:'$0,0'}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr style="height: 36px;font-weight: bold;">
                    <td>Remainder Due/Refund</td>
                    <td></td>
                    <td style="text-align: center;" *ngIf="projection.isRemainderDueOrRefundNegative">({{projection.remainderDueRefund  | formatAmount:'$0,0'}})</td>
                    <td style="text-align: center;" *ngIf="!projection.isRemainderDueOrRefundNegative">{{projection.remainderDueRefund  | formatAmount:'$0,0'}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </ng-template>
                </tbody>
              </table>
            </td>
          </tr>
        </ng-template>
      </ng-template>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="reveal['showFormulaInfo']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['showFormulaInfo']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['showFormulaInfo']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Formula Info</span>
      <span class="float-right pointer" (click)="hideReveal('showFormulaInfo')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <ng-template [ngIf]="currentFormulaKey == 'safeHarbor'">
            <p>IF PY AGI is over $150k and they are filing MFJ, then the calculation will equal PY Total Tax multiplied by 110%</p>
            <p>IF PY AGI is under $150k and they are filing MFJ, then the calculation will equal PY Total Tax multiplied by 100%</p>
            <p>IF PY AGI is over $75k and they have a filing status of Single or MFS, then the calculation will equal PY Total Tax multiplied by 110%</p>
            <p>IF PY AGI is under $75k and they have a filing status of Single or MFS, then the calculation will equal PY Total Tax multiplied by 100%</p>
          </ng-template>
          <p *ngIf="currentFormulaKey == 'currentYearExpectedMinTaxDue'">Current year expected tax multiplied by 90%</p>
          <p *ngIf="currentFormulaKey == 'minimumAmountDueToIRS'">Less of Safe Harbor Tax Due (or) Current Year Expected Minimum Tax Due</p>
          <p *ngIf="currentFormulaKey == 'remainderDueRefund'">Remainder Due/(Refund) = "Minimum amount due to IRS" - "Overpayment applied from PY" - "Estimated W-2 withholding" - "Total Estimates Recommended".</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['selectProjection']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['selectProjection']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['selectProjection']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Projection to PDF</span>
      <span class="float-right pointer" (click)="hideReveal('selectProjection')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-10 medium-10 columns">
          <div class="row dropdown-select">
            <div class="small-4 medium-4 columns">
              <label class="label-name label-top">Projections</label>
            </div>
            <div class="small-4 medium-8 columns">
              <div id="company-dropdown" style="margin-right: 10px;" class="filter-option-wrapper-max">
                <ng-multiselect-dropdown
                  name="Projection"
                  [placeholder]="'Select Projection'"
                  [settings]="projectionDropdownSettings"
                  [data]="taxProjectionsList"
                  [(ngModel)]="selectedProjectionsForPdf"
                  (onSelect)="onProjectionFilterSelect($event, true)"
                  (onDeSelect)="onProjectionFilterSelect($event, false)"
                  (onSelectAll)="onAllProjectionFilterSelect($event, true)"
                  (onDeSelectAll)="onAllProjectionFilterSelect($event, false)">
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px;">
        <div class="small-12 medium-12 columns text-right">
          <button class="button small post-button"  type="submit" (click)="exportSelectedProjections()" data-close>DOWNLOAD</button>
        </div>
      </div>
    </div>
  </div>
</div>

